module.exports = __webpack_public_path__ + "img/file.7050cdee.png";